import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { DetailedActivityComponent } from './detailed-activity/detailed-activity.component';
import { IActivityRequest } from '../../../core/interfaces/common/activity-request.interface';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-whatsapp-activity',
  templateUrl: './whatsapp-activity.component.html',
  styleUrls: ['./whatsapp-activity.component.scss']
})
export class WhatsappActivityComponent implements OnInit {

  public data: any = {};
  public isDeviceVisible: boolean = false;
  public viewConversationStatistics = new FormControl(false);

  private adminRequest: any;

  @Input() isAdmin: boolean = false;
  @Input() isInbound: boolean = false;
  @Input() ConversationsBased: boolean = false;
  @Input() customerCode: string = null;
  @Input() tabIndex: any = { value: 0 };

  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild(DetailedActivityComponent) detailedComponent: DetailedActivityComponent;

  ngOnInit(): void {
    this.viewConversationStatistics.valueChanges.subscribe(value => {
      setTimeout(() => {
        this.detailedComponent.loadInformation(this.adminRequest, this.isInbound);
      }, 300); // I added this because the component is loaded after the loadInformation method and all properties are set to default (ex: showMatCard, outboundActivitySbj)

    })

    if (this.isAdmin) {
      this.viewConversationStatistics.patchValue(this.ConversationsBased)
    }

    
  }

  openSideDialog(element: any) {
    this.data = element;
    this.isDeviceVisible = !this.isDeviceVisible;
    this.drawer.toggle();
  }

  closeSideDialog() {
    this.drawer.toggle();
    this.data = {};
    this.isDeviceVisible = !this.isDeviceVisible;
  }

  loadInformation(request: IActivityRequest, isInbound: boolean, conversationsBased: boolean) {
    this.adminRequest = request;
    this.isInbound = isInbound;

    this.viewConversationStatistics.patchValue(conversationsBased);
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex.value = event.index;
  }

}


